import { OpaqueToken } from '@angular/core';

export const TRACKING_CONFIG = new OpaqueToken('TrackingConfig');



// WEBPACK FOOTER //
// ./src/app/@shared/tracking/tracking.config.ts